'use client'

import { useEffect, useState } from 'react'

type CartCountdownProps = {
  expiresAt: string
  onExpire?: () => void
}

export function CartCountdown({ expiresAt, onExpire }: CartCountdownProps) {
  const [timeLeft, setTimeLeft] = useState('')

  useEffect(() => {
    function update() {
      const diff = new Date(expiresAt).getTime() - Date.now()
      if (diff <= 0) {
        setTimeLeft('00:00')
        onExpire?.()
        return
      }
      const minutes = Math.floor(diff / 60000)
      const seconds = Math.floor((diff % 60000) / 1000)
      setTimeLeft(`${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`)
    }
    update()
    const id = setInterval(update, 1000)
    return () => clearInterval(id)
  }, [expiresAt])

  if (!timeLeft) return null

  return (
    <p className='text-muted-foreground text-base'>
      Time left:{' '}
      <span
        className={
          timeLeft === '00:00' ? 'text-destructive font-medium' : 'font-medium tabular-nums'
        }
      >
        {timeLeft}
      </span>
    </p>
  )
}
